const d2 = [
  { genre: 'I', revenue: 10 },
  { genre: 'J', revenue: 4 },
  { genre: 'K', revenue: 11 },
  { genre: 'L', revenue: 13 },
  { genre: 'M', revenue: 1 },
  { genre: 'N', revenue: 6 },
  { genre: '0', revenue: 17 },
  { genre: 'P', revenue: 15 },
];

export default d2;
